module.exports = __webpack_public_path__ + "img/team.bb99f10b.png";